export const getters = {
  isAuthenticated(state) {
    return state.api_token !== null
  },
  getToken(state) {
    return state.api_token
  },
  getRequestComplete(state) {
    return state.request_complete
  },
  getUserName(state) {
    return state.user_name
  },
  getYippsCurrency(state) {
    return state.yipps_currency
  },
  getAvatarURL(state) {
    return state.user_avatar_url
  }
}
